import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import { ANNUAL, MONTHLY } from "../../constans";
import colors from "../../styles/colors";
import { formatDate, formatMoney } from "../../utils/Formatter";
import { addDaysToDate } from "../../utils/Date";
import Button from "../../components/Button";
import Footer from "../../components/Footer";
import Input from "../../components/Input";
import Note from "../../components/Note";
import { typography } from "../../styles/typography";
import CardPayment from "./CardPayment";
import { usePaypal } from "./usePaypal";
import { useSessionCheck } from "../../hooks/useSessionCheck";
import Loading from "../../components/Loading";
import { t } from "i18next";

export default function Payment() {
  useSessionCheck()
  const [email, setEmail] = useState(sessionStorage.getItem("email"));
  const plan = sessionStorage.getItem("plan");
  const planData = [{ title: MONTHLY, value: 4.99 }, { title: ANNUAL, value: 49 }]
  const isLoaded = useRef(false);
  const cardRef = useRef()
  const [loading, setLoading] = useState(false)
  const [complete, setComplete] = useState({
    number: false,
    expiry: false,
    cvc: false,
  });
  const allElementsValid = complete.number && complete.expiry && complete.cvc;

  function getPlanData() {
    return planData.filter((data) => data.title == plan)[0]
  }

  usePaypal({
    plan,
    email,
    onLoad: () => isLoaded.current = true
  })

  function trans(key) {
    return t('onb-web_payment_' + key)
  }

  return (
    <>
      <div style={style.container}>
        <Header withBackButton={false} />
        <div className="scrollContainer" style={style.subcontainer}>
          <div className="title title_m_24_medium">{trans(82)}</div>
          <div className="headline_16_regular mt-48" style={style.subtitle}>{trans(83)}</div>
          <div className="divider mt-8" />
          <div className="title_s_18_medium mt-32">{`Performance Mode – ${plan == MONTHLY ? t("monthly") : trans("annually")}`}</div>

          <div className="body_14_regular mt-16" style={style.subtitle}>{trans(85)}</div>
          <div className="body_14_regular mt-4">{formatMoney(0)}</div>

          <div className="body_14_regular mt-16" style={style.subtitle}>{trans(87)}</div>
          <div className="body_14_regular mt-4">{
            `${formatDate(addDaysToDate(new Date(), 30))} ${formatMoney(getPlanData().value, 2)}/${getPlanData().title == MONTHLY ? t('month') : t('year')}`}
          </div>

          <div className="body_14_regular mt-16" style={style.subtitle}>{trans(89)}</div>
          <div className="body_14_regular mt-4">{trans(90)}<br /> {trans(91)}</div>

          <div className="headline_16_regular mt-56" style={style.subtitle}>{trans(92)}</div>
          {/* PayPal */}
          <div className="mt-32" style={{ width: '100%' }}>
            <h3 className="body_15_medium">{trans(93)}</h3>
            <div className="mt-16" id="paypal-button-container"></div>
          </div>
          <div className="divider mt-32" />
          {/* Stripe */}

          <CardPayment onComplete={setComplete}
            email={email}
            plan={getPlanData().title}
            amount={getPlanData().value}
            ref={cardRef}
            onLoading={(loading) => setLoading(loading)}
          />

          {/*
          <div className="body_14_regular mt-16" style={style.subtitle}>{trans(98)}</div>
          <div className="divider mt-8" />
           <div className="caption_12_regular mt-32">Email(Optional)</div>
          <Input
            placeholder={"Enter your email"}
            containerStyle={style.emailContainer}
            onChangeText={(email) => setEmail(email)}
            value={email}
            type={"email"}
            editable={false}
          /> */}
          <Note className={"mt-24"}>
            {trans(100)}
          </Note>
          <Footer style={{ marginTop: 150 }} />
        </div>

        <div className="button-wrapper" style={{ paddingLeft: 16, paddingRight: 16 }}>
          <Button
            text={t("onb-web_subscribeplanlanding_56")}
            type="submit"
            disabled={!allElementsValid}
            className={(allElementsValid ? "primary-on-button" : "primary-off-button") + " primary-button-text"}
            onClick={(e) => {
              cardRef.current.handleStripePayment(e)
            }}
          />
        </div>

      </div>
      {loading && <Loading />}
    </>
  );
}

const style = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#000',
    color: '#fff',
    height: '100dvh',
    overflow: 'hidden'
  },
  subcontainer: {
    alignItems: 'flex-start',
    overflowY: 'scroll'
  },
  subtitle: {
    color: colors.mono300,
    width: '100%'
  },
  inputContaier: {
    border: '1px solid #23292E',
    borderRadius: 10,
    padding: '0px 16px',
    marginTop: 10
  },
  emailContainer: {
    border: '1px solid #23292E',
    borderRadius: 10,
    minHeight: 48,
    marginTop: 10
  },
  cardInputs: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    gap: 12,
    marginTop: 32
  },
  elementStyle: {
    base: {
      ...typography.body["15_regular"],
      color: "#fff",
      lineHeight: '48px',
      '::placeholder': {
        color: colors.mono500,
      }
    },
    invalid: {
      color: "#fa755a",
    },
  },
  card: {
    height: 29,
    width: 'auto'
  },
  cardIcons: {
    display: 'flex',
    gap: 10,
    width: '100%'
  }
}
